import { type Security, safeAbsurd } from '@ipfabric/utils';
import { record } from 'fp-ts';

export const getReferenceDictionaries = (
  deviceSecurity: Security.DeviceSecurity,
  type: Security.SecurityType | 'referencedTest',
  dictionary: 'local' | 'objectGroup',
): Security.ReferenceDictionaries => {
  if (type === 'referencedTest' || dictionary === 'objectGroup') {
    return deviceSecurity.objects || record.empty;
  }
  if (type === 'acl') {
    return deviceSecurity.machineAcl || record.empty;
  }
  if (type === 'nat44') {
    return deviceSecurity.machineNat44 || record.empty;
  }
  if (type === 'pbr') {
    return deviceSecurity.machinePbr || record.empty;
  }
  if (type === 'zoneFw') {
    return deviceSecurity.machineZones || record.empty;
  }
  if (type === 'cloud') {
    return deviceSecurity.machineCloud || record.empty;
  }
  safeAbsurd(type);
  return record.empty;
};
